import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const LocationWidget = () => {
  const businessHours = [
    { day: "Monday - Saturday", hours: "7:00 AM - 7:00 PM", isOpen: true },
    { day: "Sunday", hours: "8:00 AM - 5:00 PM", isOpen: true }
  ];

  const contactInfo = [
    { icon: "MapPin", text: "123 Etobicoke Street, Toronto, ON M9C 1A1" },
    { icon: "Phone", text: "(416) 555-0123" },
    { icon: "Mail", text: "hello@montesantobakery.com" }
  ];

  return (
    <section className="py-16 bg-card">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-serif text-4xl font-bold text-foreground mb-6">
              Visit Our Bakery
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Experience the warmth of authentic Italian baking in the heart of Etobicoke. We're open daily with fresh batches throughout the day.
            </p>

            <div className="space-y-6 mb-8">
              <div>
                <h3 className="font-semibold text-lg text-foreground mb-4 flex items-center gap-2">
                  <Icon name="Clock" size={20} color="var(--color-primary)" />
                  Business Hours
                </h3>
                <div className="space-y-3">
                  {businessHours?.map((schedule, index) => (
                    <div key={index} className="flex justify-between items-center p-3 rounded-lg bg-background border border-border">
                      <span className="text-sm font-medium text-foreground">{schedule?.day}</span>
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-muted-foreground">{schedule?.hours}</span>
                        {schedule?.isOpen && (
                          <span className="px-2 py-1 rounded-full bg-success/10 text-success text-xs font-medium">
                            Open
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="font-semibold text-lg text-foreground mb-4 flex items-center gap-2">
                  <Icon name="MapPin" size={20} color="var(--color-primary)" />
                  Contact Information
                </h3>
                <div className="space-y-3">
                  {contactInfo?.map((info, index) => (
                    <div key={index} className="flex items-start gap-3 p-3 rounded-lg bg-background border border-border">
                      <Icon name={info?.icon} size={18} color="var(--color-primary)" className="mt-0.5" />
                      <span className="text-sm text-muted-foreground">{info?.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <Link to="/visit-connect">
                <Button variant="default" iconName="Navigation" iconPosition="left">
                  Get Directions
                </Button>
              </Link>
              <a href="tel:4165550123">
                <Button variant="outline" iconName="Phone" iconPosition="left">
                  Call Us
                </Button>
              </a>
            </div>
          </div>

          <div className="h-[500px] rounded-2xl overflow-hidden border border-border shadow-warm">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title="Montesanto Bakery Location"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=43.6532,-79.3832&z=14&output=embed"
              className="w-full h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationWidget;